import { render, staticRenderFns } from "./PorletForm.vue?vue&type=template&id=92782b86"
import script from "./PorletForm.vue?vue&type=script&lang=js"
export * from "./PorletForm.vue?vue&type=script&lang=js"
import style0 from "./PorletForm.vue?vue&type=style&index=0&id=92782b86&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports